<template>
  <div class="default-modal share-wishlist-modal">
    <div class="default-modal__header share-wishlist-modal__header">
      <h3 class="default-modal__title share-wishlist-modal__title">
        Это не ваш список желаний — вы можете добавить его к себе
      </h3>
      <span class="share-wishlist-modal__count"
        >{{ localWishlistItems.length }} {{ getProductCountText(localWishlistItems.length) }}</span
      >
      <button type="button" class="default-modal__close share-wishlist-modal__close" @click="$emit('close')">
        <IconComponent name="close" class="default-modal__close share-wishlist-modal__close-icon" />
      </button>
    </div>
    <div class="default-modal__body share-wishlist-modal__body">
      <div class="share-wishlist-modal__content">
        <div class="share-wishlist-modal__products">
          <ProductsTableComponent :items="localWishlistItems" @remove="removeItem" is-wishlist />
        </div>

        <div class="share-wishlist-modal__total">
          <div class="share-wishlist-modal__total-row">
            <span class="share-wishlist-modal__total-label">Итого:</span>
            <span class="share-wishlist-modal__total-value">{{ totalPrice | formatPrice }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="default-modal__footer share-wishlist-modal__footer">
      <button
        v-if="isSharedWishlist"
        type="button"
        class="btn btn--md btn--main"
        :disabled="loading || localWishlistItems.length === 0"
        @click="addToWishlist"
      >
        <FileIconComponent v-if="loading" name="loading" />
        <template v-else>Добавить в свой список желаний</template>
      </button>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import FileIconComponent from "components/FileIconComponent.vue";
import ProductsTableComponent from "components/ProductsTableComponent.vue";
import ImgComponent from "components/ImgComponent.vue";

export default {
  name: "ShareWishlistModal",
  components: {
    IconComponent,
    FileIconComponent,
    ProductsTableComponent,
    ImgComponent,
  },
  props: {
    wishlistItems: {
      type: Array,
      required: true,
    },
    isSharedWishlist: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      url: "",
      hash: "",
      copied: false,
      localWishlistItems: [],
    };
  },
  created() {
    this.localWishlistItems = [...this.wishlistItems];
  },
  computed: {
    totalPrice() {
      return this.localWishlistItems.reduce((total, item) => {
        if (!item || !item.item) return total;

        let price = item.item.price;
        if (item.item.join_share && item.item.join_share.share) {
          price = (price * (100 - parseFloat(item.item.join_share.share.percent))) / 100;
        }

        return total + price;
      }, 0);
    },
  },
  methods: {
    inWishlist(item) {
      return !!this.$store.state.auth.favorites.find((c) => c.item_id === item?.id);
    },

    removeItem(ids) {
      this.localWishlistItems = this.localWishlistItems.filter((item) => {
        if (!item) {
          return false;
        }

        const itemId = item.item.id;
        const shouldKeep = !ids.includes(itemId);
        return shouldKeep;
      });
    },

    getProductCountText(count) {
      const lastDigit = count % 10;
      const lastTwoDigits = count % 100;

      if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return "товаров";
      }

      if (lastDigit === 1) {
        return "товар";
      }

      if (lastDigit >= 2 && lastDigit <= 4) {
        return "товара";
      }

      return "товаров";
    },

    async addToWishlist() {
      if (this.loading || this.localWishlistItems.length === 0) return;

      try {
        const items = this.localWishlistItems.map((item) => ({
          item: item.item,
          quantity: item.quantity || 1,
        }));

        this.loading = true;

        // Добавляем товары в список желаний
        for (const item of items) {
          if (!this.inWishlist(item.item)) {
            await this.$store.dispatch("FAVORITE_CREATE_OR_DELETE", {
              apollo: this.$apollo,
              variables: {
                item_id: item.item.id,
              },
            });
          }
        }

        this.$emit("close");

        this.$notify({
          type: "success",
          title: "Успешно",
          text: "Товары добавлены в ваш список желаний",
        });

        this.$router.push({ name: "user", params: { link: "wishlist" } });
      } catch (error) {
        console.error("Ошибка при добавлении товаров в список желаний:", error);
        this.$notify({
          type: "error",
          title: "Ошибка",
          text: "Не удалось добавить товары в список желаний",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="stylus">
.share-wishlist-modal {
    padding: 50px;
		width: 100vw;
		max-width: 1010px;

    &__header {
        border-bottom: none;
        padding: 0;
        justify-content: flex-start;

        & span {
            color: var(--main-color);
        }
    }

    &__title {
        font-size: 22px;
        font-weight: 600;
        text-transform: none;
    }

    &__body {
        padding: 0;
        margin-top 40px
    }

    &__close-icon {
        transform: translate(-10%, -10%) rotate(45deg);
    }

    &__footer {
        padding: 0;
        margin-top 40px
    }

    &__content {
        display: grid;
        grid-gap: 20px;
				width: 100%;
    }

    &__url {
        margin-bottom: 10px;

        p {
            margin-bottom: 10px;
            font-weight: 500;
        }
    }

    &__url-container {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    &__url-input {
        flex: 1;
        padding: 10px;
        border: 1px solid var(--gray);
        border-radius: var(--main_radius);
        font-size: 14px;
        background: var(--gray_o5);
        color: var(--body-color);
    }

    &__products {
        h4 {
            margin-bottom: 15px;
            font-weight: 500;
        }
    }

    &__total {
        margin-top: 30px;
        padding-top: 20px;
    }

    &__total-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
    }

    &__total-label {
        font-size: 22px;
        font-weight: 600;
    }

    &__total-value {
        font-size: 22px;
        font-weight: 600;
        color: #000;
    }
}
</style>
